import { createContext, useContext, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const AddOnsSearchContext = /*#__PURE__*/createContext(null);
export const AddOnsSearchProvider = ({
  children
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  return /*#__PURE__*/_jsx(AddOnsSearchContext.Provider, {
    value: {
      searchTerm,
      setSearchTerm
    },
    children: children
  });
};
export const useAddOnsSearch = () => {
  const context = useContext(AddOnsSearchContext);
  if (!context) {
    throw new Error('useAddOnsSearch must be used within an AddOnsSearchProvider');
  }
  return context;
};